import { useQueryClient } from '@tanstack/react-query';
import { LoyaltyStatus } from '@/components/LoyaltyStatus';
import { VeriffModal } from '@/modals/VeriffModal';
import { VerificationBonusInfoModal } from '@/modals/VerificationBonusInfoModal';
import { BonusVerificationSuccessModal } from '@/modals/BonusVerificationSuccessModal';
import { ComplianceSubmitModal } from '@/modals/ComplianceSubmitModal';
import { CountryVerificationModal } from '@/modals/CountryVerificationModal';
import { InvestorDecisionWidget } from '@/containers/InvestorDecisionWidget';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { QUERY_KEYS } from '@/query/queryKeys';
import { VERIFF_CODES } from '@/helpers/constants';
import { useModal } from '@/providers/modal';
import { DashboardMessages } from './components/DashboardMessages';
import { RoundInfo } from './components/RoundInfo';
import { InvestmentHistory } from './components/InvestmentHistory';
import { DashboardMiniFaq } from './components/DashboardMiniFaq';
import { InvestmentStreakStatus } from './components/InvestmentStreakStatus';
import { HappyBrands } from './components/HappyBrands';
import { Offers } from './components/Offers';
import s from './index.module.scss';

const DashboardPage = () => {
  const { closeModal } = useModal();
  const queryClient = useQueryClient();

  return (
    <div className={s.page}>
      <div className="g-container">
        <div className={s.container}>
          <DashboardMessages />
          <div className={s.overview}>
            <div className={s.header}>
              <RoundInfo />
              <Offers />
            </div>
            <InvestmentHistory />
            <HappyBrands />
          </div>
          <div className={s.deals}>
            <InvestmentStreakStatus />
            <LoyaltyStatus />
          </div>
          <DashboardMiniFaq />
        </div>
      </div>
      <>
        <VerificationBonusInfoModal />
        <BonusVerificationSuccessModal />
        <ComplianceSubmitModal />
        <VeriffModal />
        <CountryVerificationModal
          onSuccess={() => {
            closeModal(MODAL_IDS.country_verification);
            queryClient.setQueryData([QUERY_KEYS.user.veriff_status], () => ({
              code: VERIFF_CODES.submitted,
            }));
          }}
        />
      </>

      <InvestorDecisionWidget placement="dashboard" />
    </div>
  );
};

export default DashboardPage;
